import { LicenseInfo } from '@ori-ui/mui-bundle/x-license-pro';
const applyLicense = () => LicenseInfo.setLicenseKey('c8cd1383dc4459ba9cdef25e543dbaddT1JERVI6NjkxMzYsRVhQSVJZPTE3MTkxNDgwMDMzMzksS0VZVkVSU0lPTj0x');
export default applyLicense;
//# sourceMappingURL=applyLicense.js.map